import { Profile } from 'oidc-client';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { DrawerState } from '../../../core/models/enum';
import { MatchFormInitialValues } from '../../../core/models/InitialValues';
import { RouteParams } from '../../../core/models/RouteHelper';
import { MatchDetailVm } from '../../../utils/api';
import MatchForm from './MatchForm';

interface OwnProps {
    matchFromProps?: MatchDetailVm;
    initialValues?: MatchFormInitialValues;
    handleClose: (drawerMode: DrawerState, id?: string) => void;
    refreshAfterSave: () => void;
    /** When true (e.g. match table side drawer), show red Delete next to Save if user may delete. */
    showDeleteInDrawer?: boolean;
    userProfile?: Profile;
    /** After successful delete (refresh list, close drawer, etc.). */
    onDeleted?: () => void | Promise<void>;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(MatchForm);
